/** @format */
import { Icon, Tag } from '@king-design/react'
import React from 'react'
import {
  TriggerRuleKeyEnum,
  TriggerRuleKeyAggEnum,
  TriggerRuleOperatorOpts
} from './components/RuleDrawer/container'
import { ConcatProps } from 'src/components/AlarmReciver/new'
// 类型定义
export interface TriggerConditionType {
  Key: keyof typeof TriggerRuleKeyEnum | keyof typeof TriggerRuleKeyAggEnum | ''
  Value: string | number | string[] | number[]
  Operator: typeof TriggerRuleOperatorOpts[number]
}
export const initTriggerCondition: TriggerConditionType = {
  Key: 'namespaceid',
  Value: '',
  Operator: '=='
}

export const initTriggerConditionAgg: TriggerConditionType = {
  Key: '',
  Value: '',
  Operator: '=='
}
interface LogItemProps {
  ID: number
  AccountID: string
  Module: string
  ModuleSign: string
  ModuleID: number
  Title: string
  Type: string
  Status: number
  Remark: string
  Operator: string
  CreatedAt: string
  UpdatedAt: string
}

// 触发器列表项
export interface TriggerRecordItemProp {
  ID?: number
  Sign: string
  Name: string
  TriggerType: keyof typeof TriggerTypeEnum
  ActionType: keyof typeof ActionTypeEnum
  Creator?: string
  PublishedAt?: string
  Version?: string
  TriggerTimes?: number
  Status?: number
  Logs?: LogItemProps[]
  Approving: boolean
}

// 触发器详情
export interface TriggerDetailItemProp extends TriggerRecordItemProp {
  AccountID?: string
  ActionName?: string
  ActionSign?: string
  ActionType: keyof typeof ActionTypeEnum
  ActionParams?: {
    Outputs: string[]
    ScriptID: number
  }
  TriggerConditions?: {
    Conditions?: TriggerConditionType[][]
    CronSpec?: string
  }
  Limiter: {
    Max: number
    Duration: number
  }
  Notice: {
    Events: string[]
    UrlNotices: string[]
    UserNotices: ConcatProps[]
  }
  VersionRemark?: string
}

export const TriggerTypeEnum = {
  monitor_event: '事件',
  monitor_event_agg: '事件聚合',
  crontab: '定时任务'
}

// 触发动作
export const ActionTypeEnum = {
  location: '自动化场景',
  custom: '自定义'
}

// 通知订阅
export const NoticeTypeEnum = {
  trigger_before: '触发开始',
  trigger_after: '触发结束（成功）',
  trigger_after_fail: '触发结束（失败）'
}

// 状态
export function getStatus(text: string | number) {
  switch (text) {
    case -1:
    case '-1':
      return (
        <Tag border="solid" type="danger">
          已停用
        </Tag>
      )
    case 1:
    case '1':
      return (
        <Tag border="solid" type="default">
          <Icon className="k-icon-time" />
          <span style={{ marginLeft: 2 }}>已创建</span>
        </Tag>
      )
    case 2:
    case '2':
      return (
        <Tag border="solid" type="primary">
          <Icon style={{ color: '#0091ea' }} className="k-icon-refresh" />
          <span style={{ marginLeft: 2 }}>启用中</span>
        </Tag>
      )
    case -2:
    case '-2':
      return (
        <Tag
          border="solid"
          style={{ backgroundColor: '#e6f9ff', borderColor: '#7ad9ff', color: '#0091ea' }}
        >
          <Icon style={{ color: '#0091ea' }} className="k-icon-user" />
          <span style={{ marginLeft: 2 }}>审批中</span>
        </Tag>
      )
    case -3:
    case '-3':
      return (
        <Tag border="solid" type="warning">
          <Icon style={{ color: '#ff9a05' }} className="k-icon-time" />
          <span style={{ marginLeft: 2 }}>预发布</span>
        </Tag>
      )
  }
}

// 定时触发:解析crontab表达式
export const getCronSpecValue = (cronSpec: string) => {
  if (!cronSpec) return {}
  const [, minute, hour, dom, month, dow] = cronSpec?.split(' ')
  return {
    minute: minute || 1,
    hour: hour || '*',
    dom: dom || '*',
    month: month || '*',
    dow: dow || '*'
  }
}

// 数据处理：输出参数
export const getOutputParams = (content: string, lang: 'python3' | 'shell') => {
  const reg =
    lang === 'shell'
      ? new RegExp(/(?:^|\s+)(OutPrint|g_print)[\s]+["']?([\u4e00-\u9fa5_a-zA-Z0-9_]*)/gi)
      : new RegExp(/(?:^|\s+)(OutPrint|g_print)\([\s]?["']+([\u4e00-\u9fa5_a-zA-Z0-9_]*)/gi)

  const outputData: string[] = []
  let match
  // 使用 exec 方法替代 matchAll，兼容性更好
  while ((match = reg.exec(content)) !== null) {
    if (match[2]) {
      outputData.push(match[2])
    }
  }

  return outputData
}
